/**
 * @copyright © 2026 ASAP Technology. All rights reserved.
 * @license BSL-1.1 (see LICENSE file)
 *
 * @file deviceSummary.ts
 * @description Resumen liviano del dispositivo/navegador del comprador (sin llamadas
 * de red). Se envía al backend para comparar contra el dispositivo ESPERADO que el
 * comercio puede declarar en OrderInitial (PaymentForm.ExpectedDevice). Si difiere,
 * el backend puede denegar. Solo aplica a modelos integrados (es opt-in del comercio).
 */
export interface DeviceSummary {
  browser: string;
  os: string;
  deviceType: 'desktop' | 'mobile' | 'tablet';
  language: string;
  timezone: string;
}

export function getDeviceSummary(): DeviceSummary {
  const ua = navigator.userAgent || '';
  const browser =
    /edg/i.test(ua) ? 'Edge'
    : /opr|opera/i.test(ua) ? 'Opera'
    : /chrome|crios/i.test(ua) ? 'Chrome'
    : /firefox|fxios/i.test(ua) ? 'Firefox'
    : /safari/i.test(ua) ? 'Safari'
    : 'Other';
  const os =
    /windows/i.test(ua) ? 'Windows'
    : /android/i.test(ua) ? 'Android'
    : /iphone|ipad|ipod/i.test(ua) ? 'iOS'
    : /mac os|macintosh/i.test(ua) ? 'macOS'
    : /linux/i.test(ua) ? 'Linux'
    : 'Other';
  const deviceType: DeviceSummary['deviceType'] =
    /ipad|tablet/i.test(ua) ? 'tablet'
    : /mobile|iphone|android/i.test(ua) ? 'mobile'
    : 'desktop';
  let timezone = '';
  try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { /* noop */ }
  return { browser, os, deviceType, language: navigator.language || '', timezone };
}
